"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaScriptAsyncSrc = exports.TeaChannelDomainMap = exports.TeaChannelTypeMap = exports.TeaChannelMap = void 0;
const region_1 = require("../../i18n/region");
exports.TeaChannelMap = {
    [region_1.ClientBuildRegion.SG]: 'sg',
    [region_1.ClientBuildRegion.VA]: 'va',
    [region_1.ClientBuildRegion.OCI]: 'va',
};
exports.TeaChannelTypeMap = {
    [region_1.ClientBuildRegion.SG]: 'tcpy',
    [region_1.ClientBuildRegion.VA]: 'tcpy',
    [region_1.ClientBuildRegion.OCI]: 'ttp',
};
// See https://bytedance.larkoffice.com/wiki/YMJIwW6N0ie51Xk2vjlcQ8iRnQc
exports.TeaChannelDomainMap = {
    [region_1.ClientBuildRegion.SG]: 'https://mcs-sg.lemon8-app.com',
    [region_1.ClientBuildRegion.VA]: 'https://mcs-va.lemon8-app.com',
    [region_1.ClientBuildRegion.OCI]: 'https://mcs-ttp.lemon8-app.us',
};
exports.TeaScriptAsyncSrc = {
    [region_1.ClientBuildRegion.SG]: 'https://lf-lemon8-web-sg.ttwstatic.com/obj/lemon8-web-sg/log-sdk/collect/5.2/oversea/collect.js',
    [region_1.ClientBuildRegion.VA]: 'https://lf-lemon8-web-va.ttwstatic.com/obj/lemon8-web-us/log-sdk/collect/5.2/oversea/collect.js',
    [region_1.ClientBuildRegion.OCI]: 'https://lf-lemon8-web.tiktokcdn-us.com/obj/static-tx/log-sdk/collect/5.2/collect.js',
};
